import React, { useState } from "react";

const ToggleButton = ({ value, handleToggleStatus, roleId, roleType }) => {
  const [isOn, setIsOn] = useState(false);

  const toggleSwitch = () => {
    setIsOn(!isOn);
  };

  console.log("value", value);
  console.log("roleId", roleId);

  return (
    <div
      onClick={() =>
        roleType !== "admin" ? handleToggleStatus(roleId) : () => {}
      }
      className={`relative inline-flex items-center ${
        roleType !== "admin" && `cursor-pointer`
      }  w-[50px] h-6 rounded-full transition-colors ${
        value?.original?.status ? "bg-green-500" : "bg-gray-300"
      }`}
    >
      {/* Toggle Circle */}
      <div
        className={`absolute w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
          value?.original?.status ? "translate-x-6" : "translate-x-1"
        }`}
      ></div>
    </div>
  );
};

export default ToggleButton;
